import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Cover, Image, Input, Layout, SEO } from 'components';
import { routes } from 'utils/routes';
import { cta } from 'utils/cta';
import { media } from "utils/media";

// Content
import contentSEO from "cms/content/contact-seo.yml";
import contentCover from "cms/content/contact-cover.yml";
import contentForm from "cms/content/contact-section-form.yml";
import contentInquiries from "cms/content/contact-section-inquiries.yml";
import contentSocial from "cms/content/contact-section-social.yml";

const formFeedback = [
  contentForm.sending,
  contentForm.success,
  contentForm.error,
];

const ContactUsPage = ({ pageContext: { locale }, location }) => {
  const [formStatus, handleFormStatus] = useState(-1);
  const [formError, handleFormError] = useState(null);
  const sending = () => handleFormStatus(0);
  const success = () => handleFormStatus(1);
  const failed = () => handleFormStatus(2);

  const handleSubmit = (ev) => {
    ev.preventDefault();
    handleFormError(null);
    sending();
    // todo: update url
    const url = 'https://www.straightteethdirect.com/wp-json/contact-form-7/v1/contact-forms/17/feedback';
    const data = new FormData(ev.target);

    fetch(url, {
      method: 'POST',
      body: data,
      credentials: "same-origin",
    }).then(function(response) {
      // response.status     //=> number 100–599
      // response.statusText //=> String
      // response.headers    //=> Headers
      // response.url        //=> String
      success();
      // return response.text();
    }, function(error) {
      failed();
      handleFormError(error.message);
    });
  };

  return (
    <Layout locale={locale} className='contacts-wrapper'>
      <SEO
        title={contentSEO.title}
        description={contentSEO.description}
        lang={locale}
        keywords={contentSEO.keywords}
        location={location}
        image={contentSEO.socialImage}
      />

      <Cover
        title={contentCover.title}
        image={{ url: media(contentCover.image), alt: 'Contact Straight Teeth Direct' }}
        button={{ label: cta.getStarted, ...routes.getStarted }}
        trustpilot={contentCover.trustpilot}
      />

      <p className='t-center' dangerouslySetInnerHTML={{ __html: contentForm.text }} />

      <form onSubmit={handleSubmit} className='form-wrapper'>
        <Input id='name' name='Name' placeholder='What’s your name?' required />
        <Input id='email' name='Email' placeholder='What’s your email address?' type='email' required />
        <Input id='message' name='Message' placeholder='Write your message here' type='textarea' required />
        {formStatus > -1 &&
          <p className='ml-20 mr-20'>
            <b>
              {formFeedback[formStatus]}
              {formError && <span className='block red'><br/>{formError}</span>}
            </b>
          </p>
        }
        <Button label={contentForm.submitText} level='outline' />
      </form>

      {contentInquiries.blocks.map(({ title, text, handle }) => (
        <>
        <h3 className='mb-10 section-title'>{title}</h3>
        {text && <p className='section-title t-center' dangerouslySetInnerHTML={{ __html: text }}/>}
        <p className='mb-40 t-center o-60'>{handle}</p>
        </>
      ))}

      <h2 className='section-title mt-90 mb-50'>{contentSocial.title}</h2>
      <div className='section-social mb-90'>
        <p className='t-center social-tag'>{contentSocial.handle}</p>

        <div className='social-links'>
          {contentSocial.social.map(({ icon, alt, link }) => (
            <a href={link} target="_blank" rel="noopener noreferrer" path={link}>
              <Image url={media(icon)} alt={alt} />
            </a>
          ))}
        </div>
      </div>
    </Layout>
  );
};

ContactUsPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default ContactUsPage;
